// MS buffer before calling all window resize functions
var iWindowResizeTimeout = 75;

var lang = document.getElementsByTagName("body")[0].className.match(/lang-fr/) ? 'fr' : 'en';

var termPrev = (lang === 'fr') ? "Précédent" : "Previous";
var termNext = (lang === 'fr') ? "Suivant" : "Next";

var termOpenClose = (lang === 'fr') ? "Ouvrir/Fermer" : "Open/Close";

// https://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

function pgs_is_number(sValue) {
  return parseInt(sValue) > 0 || parseInt(sValue) < 1 ;
}
